/* global ma */

const getLocalStorageData = () => {
  let userId = localStorage.getItem('userId');
  return JSON.parse(userId) || "";
};
export default getLocalStorageData;
